export default __webpack_public_path__ + "static/media/elecbitsLogo.5b890559.svg";